import { PRESUPUESTADOR_UPDATE_VEHICLE_DATA } from './constants'

export function updateVehicleData( args={}, levelTop = false) {
  return dispatch => {
    dispatch({
      type: PRESUPUESTADOR_UPDATE_VEHICLE_DATA,
      data: {args, levelTop}
    })
  }
}

export function reducer(state, action) {
  if (action.type === PRESUPUESTADOR_UPDATE_VEHICLE_DATA) {
      const level = action.data.levelTop 
      ? action.data.args
      : { nuevo: {
                    ...state.nuevo,
                    ...action.data.args,
                  }}
     return {
        ...state,
        ...level,
      }
  }
  else {
      return state
  }
}